export default __webpack_public_path__ + "static/media/Cuirass of the Sanguine Disciple (nm).3e2e0403.jpg";